<template>
  <component :is="tag" v-if="firstTopic.title" class="fields field-topic" :style="{'color': color}">
    <term-link :tid="firstTopic.tid" :title="firstTopic.title" :url="firstTopic.relative_url" :type="firstTopic.type">{{ truncate(firstTopic.title, {length: truncateLength > 0 ? this.truncateLength : 999, separator: /,? +/,}) }}</term-link>
  </component>
</template>
<script>
import head from 'lodash/head'
import isArray from 'lodash/isArray'
import truncate from 'lodash/truncate'

import TermLink from 'components/term/Link'

export default {
  name: 'field-topic',
  components: {
    TermLink,
  },
  props: {
    color: {
      type: String,
      default: '',
    },
    topics: [Array, Object],
    tag: {
      type: String,
      default: 'div',
    },
    truncateLength: {
      type: [Number, String],
      default: 999,
    },
  },
  computed: {
    firstTopic() {
      let topic = {}
      if (isArray(this.topics)) {
        topic = head(this.topics)
      }
      return topic
    },
  },
  data() {
    return {}
  },
  methods: {
    truncate,
  },
}
</script>



// WEBPACK FOOTER //
// Topic.vue?791e1b26